import React from 'react';

class RowItemKetQuaThanhTraHanhChinh extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.tongSoCuocThanhTra}</td>
        <td className='txt-center'>{data.kyTruocChuyenSang}</td>
        <td className='txt-center'>{data.trienKhaiTrongKyBaoCao}</td>
        <td className='txt-center'>{data.theoKeHoach}</td>
        <td className='txt-center'>{data.dotXuat}</td>
        <td className='txt-center'>{data.ketThucThanhTraTrucTiep}</td>
        <td className='txt-center'>{data.daBanHanhKetLuan}</td>
        <td className='txt-center'>{data.soDonViDuocThanhTra}</td>
        <td className='txt-center'>{data.soDonViCoViPham}</td>
        <td className='txt-center'>{data.tongViPhamTien}</td>
        <td className='txt-center'>{data.tongViPhamDat}</td>
        <td className='txt-center'>{data.kienNghiThuHoiTien}</td>
        <td className='txt-center'>{data.kienNghiThuHoiDat}</td>
        <td className='txt-center'>{data.kienNghiKhacTien}</td>
        <td className='txt-center'>{data.kienNghiKhacDat}</td>
        <td className='txt-center'>{data.kienNghiXLHanhChinhToChuc}</td>
        <td className='txt-center'>{data.kienNghiXLHanhChinhCaNhan}</td>
        <td className='txt-center'>{data.kienNghiXLVu}</td>
        <td className='txt-center'>{data.kienNghiXLDoiTuong}</td>
        <td className='txt-center'>{data.daThuTien}</td>
        <td className='txt-center'>{data.daThuDat}</td>
        <td className='txt-center'>{data.tongSoKLTTVaQDXLDaKTDD}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocTienPhaiThu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocTienDaThu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDatPhaiThu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDatDaThu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDaXuLyHCToChuc}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDaXuLyHCCaNhan}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDaKhoiToVu}</td>
        <td className='txt-center'>{data.ketQuaKiemTraDonDocDaKhoiToDoiTuong}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemKetQuaThanhTraHanhChinh;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemKetQuaThanhTraHanhChinh.jsx